const REQUIRED_AVAILABILITY_FILTER = 'filter.v.availability';

const SEARCH_COLLATOR = new Intl.Collator(
  typeof document === 'undefined' ? undefined : document.documentElement.lang || undefined,
  { usage: 'search', sensitivity: 'base', ignorePunctuation: true }
);

function preselectSearchFilter() {
  const currentURL = new URL(window.location.href);
  const query = currentURL.searchParams.get('q')?.trim();
  if (!query) return;

  for (const parameter of currentURL.searchParams.keys()) {
    if (parameter.startsWith('filter.') && parameter !== REQUIRED_AVAILABILITY_FILTER) return;
  }

  const resultsList = document.querySelector('results-list[data-search-vendors]');
  const facetsForm = document.querySelector('facets-form-component[data-primary-facets-form]');
  if (!resultsList || !facetsForm) return;

  let vendors;
  let productTypes;
  try {
    vendors = JSON.parse(resultsList.dataset.searchVendors ?? '[]');
    productTypes = JSON.parse(resultsList.dataset.searchProductTypes ?? '[]');
  } catch {
    return;
  }
  if (!Array.isArray(vendors) || !Array.isArray(productTypes)) return;

  const queryTokens = String(query)
    .replace(/[.'’‘`´ʼ＇]/g, '')
    .replace(/[\p{P}\p{S}]+/gu, ' ')
    .trim()
    .replace(/\s+/g, ' ')
    .split(' ');
  if (!queryTokens[0]) return;

  const vendorCandidates = [];
  const matches = [];

  for (const vendor of vendors) {
    if (typeof vendor !== 'string') continue;

    const normalizedVendor = vendor
      .replace(/[.'’‘`´ʼ＇]/g, '')
      .replace(/[\p{P}\p{S}]+/gu, ' ')
      .trim()
      .replace(/\s+/g, ' ');
    const vendorTokens = normalizedVendor.split(' ');
    if (!vendorTokens[0]) continue;

    const equivalentVendor = vendorCandidates.find(
      (candidate) => SEARCH_COLLATOR.compare(candidate.vendor, normalizedVendor) === 0
    );
    if (!equivalentVendor) {
      vendorCandidates.push({ vendor: normalizedVendor, tokens: vendorTokens });
    }

    let matchStart = null;

    querySpans: for (
      let start = 0;
      start <= queryTokens.length - vendorTokens.length;
      start += 1
    ) {
      for (let offset = 0; offset < vendorTokens.length; offset += 1) {
        if (SEARCH_COLLATOR.compare(queryTokens[start + offset], vendorTokens[offset]) !== 0) {
          continue querySpans;
        }
      }

      matchStart = start;
      break;
    }

    if (matchStart === null) continue;

    const equivalentMatch = matches.find(
      (match) => SEARCH_COLLATOR.compare(match.vendor, normalizedVendor) === 0
    );
    if (equivalentMatch) continue;

    matches.push({
      vendor: normalizedVendor,
      start: matchStart,
      end: matchStart + vendorTokens.length,
      tokenCount: vendorTokens.length,
    });
  }
  const productTypeTokens = [];

  for (const productType of productTypes) {
    if (typeof productType !== 'string') continue;

    const tokens = productType
      .replace(/[.'’‘`´ʼ＇]/g, '')
      .replace(/[\p{P}\p{S}]+/gu, ' ')
      .trim()
      .replace(/\s+/g, ' ')
      .split(' ');

    for (const token of tokens) {
      if (
        token &&
        !productTypeTokens.some(
          (productTypeToken) => SEARCH_COLLATOR.compare(productTypeToken, token) === 0
        )
      ) {
        productTypeTokens.push(token);
      }
    }
  }

  if (matches.length === 0) {
    for (const vendorCandidate of vendorCandidates) {
      let matchStart = null;
      queryTokenSearch: for (let start = 0; start < queryTokens.length; start += 1) {
        if (
          productTypeTokens.some(
            (productTypeToken) =>
              SEARCH_COLLATOR.compare(queryTokens[start], productTypeToken) === 0
          )
        ) {
          continue;
        }
        for (const vendorToken of vendorCandidate.tokens) {
          if (SEARCH_COLLATOR.compare(queryTokens[start], vendorToken) === 0) {
            matchStart = start;
            break queryTokenSearch;
          }
        }
      }

      if (matchStart === null) continue;

      matches.push({
        vendor: vendorCandidate.vendor,
        start: matchStart,
        end: matchStart + 1,
        tokenCount: 1,
      });
    }
  }

  const intendedMatches = matches.filter(
    (match) =>
      !matches.some(
        (otherMatch) =>
          otherMatch.tokenCount > match.tokenCount &&
          otherMatch.start <= match.start &&
          otherMatch.end >= match.end
      )
  );
  if (intendedMatches.length !== 1) return;

  const inputs = [
    ...facetsForm.querySelectorAll('input[name="filter.p.vendor"][data-url-to-add]'),
  ].filter((input) => !input.checked && !input.disabled);
  const input = inputs.find((candidate) => {
    const normalizedLabel = String(candidate.dataset.label ?? '')
      .replace(/[.'’‘`´ʼ＇]/g, '')
      .replace(/[\p{P}\p{S}]+/gu, ' ')
      .trim()
      .replace(/\s+/g, ' ');

    return SEARCH_COLLATOR.compare(normalizedLabel, intendedMatches[0].vendor) === 0;
  });
  if (!input) return;

  let targetURL;
  try {
    targetURL = new URL(input.dataset.urlToAdd, window.location.origin);
  } catch {
    return;
  }

  const hasExpectedValue = targetURL.searchParams.getAll(input.name).includes(input.value);
  if (targetURL.origin !== window.location.origin || !hasExpectedValue) return;

  for (const param of new Set(currentURL.searchParams.keys())) {
    if (
      param.startsWith('filter.') ||
      param === 'sort_by' ||
      param === 'section_id'
    ) {
      continue;
    }

    targetURL.searchParams.delete(param);
    for (const value of currentURL.searchParams.getAll(param)) {
      targetURL.searchParams.append(param, value);
    }
  }

  window.location.replace(targetURL);
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preselectSearchFilter, { once: true });
  } else {
    preselectSearchFilter();
  }
}
